import { gql } from "generated-graphql";
import { reportStepMetadata } from "util/reportStepMetadata";
import { StepperPageHeader } from "../StepperPageHeader";
import { useHmbpFeature } from "../useHmbp";
import { useReport } from "../useReport";
import { HmbpForm } from "./HmbpForm";
import { StateInformationForm } from "./StateInformationForm";

gql(`
  fragment stateInfo on Facility {
    stateFields {
      ...dynamicField
    }
    undergroundStorageTanks {
      ...undergroundStorageTank
    }
  }
`);

export function StateInformation() {
  const { data } = useReport();
  const hmbp = useHmbpFeature(data?.tierIIReport?.facility.state ?? "");

  return (
    <>
      <StepperPageHeader
        header="State Information"
        description={reportStepMetadata.STATE_INFORMATION.getOverviewDescription(
          {
            isHmbp: hmbp,
          }
        )}
      />
      {hmbp ? <HmbpForm /> : <StateInformationForm />}
    </>
  );
}
